import type { Validator } from '../types';
// Specific QIC validators
export type QicValidatorName ='qidLength11'
  | 'qidStartsWith23'
  | 'phoneLength11'
  | 'phoneStartsWith3567'
  | 'phoneLessDigits'
  | 'phoneCompleted'
  | 'phoneLengthBetween7and13'
  | 'phoneMinLengthRebranding'
  | 'fullNameAllowedCharacters';

const qicValidators: {[key in QicValidatorName]: Validator} = {
  qidLength11: {
    messageT: 'qic.error.qid.consist_11_digits',
    message: 'It has to consist of 11 digits',
    validator: (value: string) => value.length === 11,
  },
  qidStartsWith23: {
    messageT: 'qic.error.qid.consist_11_digits',
    message: 'It has to consist of 11 digits',
    validator: (value: string) => /^[2-3]/.test(value) && !/0{5}$/g.test(value),
  },
  phoneCompleted: {
    messageT: 'qic.error.phone.less_digits',
    message: 'Phone is not filled',
    validator: (value: unknown) => value === true
  },
  phoneLength11: {
    messageT: 'qic.error.phone.consist_11_digits',
    message: 'It has to consist of 11 digits',
    validator: (value: string) => value.length === 11,
  },
  phoneMinLengthRebranding: {
    messageT: 'qic.error.phone.consist_11_digits',
    message: 'It has to consist of 11 digits',
    validator: (value: string) => value.length ? value.length >= 14 : true,
  },
  phoneLengthBetween7and13: {
    messageT: 'qic.error.phone.consist_7_13_digits',
    message: 'Mobile number input is not between 7 and 13',
    validator: (value: string) => value.length >= 7 && value.length <=13,
  },
  phoneStartsWith3567: {
    messageT: 'qic.error.phone.start_with_3_5_6_7',
    message: 'It has to start with 3, 5, 6, 7',
    validator: (value: string) => {
      value = value.replace(/\s/g, '').replace('+', '');
      return  value.length ? /^974[3567]/.test(value) : true;
    },
  },
  phoneLessDigits: {
    messageT: 'qic.error.phone.less_digits',
    message: 'Enter the full mobile number',
    validator: (value: string) => value.length === 11,
  },
  fullNameAllowedCharacters: {
    messageT: 'qic.error.fullNameAllowedCharacters',
    message: 'Allow only letters, dash, apostrophe and a space',
    validator: (value: string) => {
      const fullNameRegex = /\p{Alpha}|[-|`|'|"|\s]/gu;
      const matches = value.match(fullNameRegex) ?? [];
      return matches.length === value.length;
    },
  },
}

export default qicValidators;
